// eslint-disable-next-line import/prefer-default-export
import {
  getToken,
} from './login.js';

export const isLoginRequired = () => {
  if (getToken()) {
    return false;
  }

  window.location.href = 'login';
  return true;
};
